import React from 'react';
import { OrganizationFields } from './fields/OrganizationFields';
import { CoreQuoteFields } from './fields/CoreQuoteFields';
import { EventFields } from './fields/EventFields';
import { AdditionalInsureds } from './fields/AdditionalInsureds';
import { getQuoteOptions } from '../api';
import { CurrentStep } from './Quote';
export const QuoteForm = (props) => {
    const { order, onChange, errors, currentStep } = props;
    const [loading, setLoading] = React.useState(false);
    const [states, setStates] = React.useState([]);
    const [activities, setActivities] = React.useState([]);
    const [brokerInfo, setBrokerInfo] = React.useState();
    const [defaultAdditionalInsured, setDefaultAdditionalInsured] = React.useState();
    const activity = activities.find((a) => a.id === order.activity_id);
    const getOptions = async () => {
        setLoading(true);
        const data = await getQuoteOptions();
        setStates(data.states);
        setActivities(data.activities);
        setBrokerInfo(data.broker);
        setDefaultAdditionalInsured(data.default_additional_insured);
        if (data.broker) {
            const brokerData = data.broker;
            onChange({
                ...order,
                broker_attributes: {
                    name_of_licensed_agency: brokerData.agency_name || '',
                    name_of_licensed_individual_servicing_account: brokerData.licensed_agent || '',
                    phone: brokerData.agency_phone || '',
                    email_address: brokerData.agent_contact_email || '',
                    address_attributes: {
                        ...(brokerData.agency_address || {}),
                        ...((order.broker_attributes || {}).address_attributes || {}),
                    },
                    ...(order.broker_attributes || {}),
                },
            });
        }
        setLoading(false);
    };
    React.useEffect(() => {
        getOptions();
    }, []);
    if (loading) {
        return React.createElement("div", null, "Loading...");
    }
    return (React.createElement("form", { autoComplete: "off" },
        React.createElement(CoreQuoteFields, { order: order, onChange: (o) => onChange(o), states: states, activities: activities, brokerInfo: brokerInfo, errors: errors }),
        currentStep >= CurrentStep.Event &&
            order.organization_attributes &&
            order.contact_attributes &&
            order.event_attributes &&
            activity && (React.createElement(React.Fragment, null,
            React.createElement(OrganizationFields, { orderId: order.id, states: states, onOrganizationChange: (organization) => {
                    onChange({
                        ...order,
                        organization_attributes: organization,
                    });
                }, onContactChange: (name, value) => {
                    onChange({
                        ...order,
                        contact_attributes: {
                            ...order.contact_attributes,
                            [name]: value,
                        },
                    });
                }, contact: order.contact_attributes, organization: order.organization_attributes, errors: errors }),
            React.createElement(EventFields, { states: states, onEventChange: (event) => {
                    onChange({
                        ...order,
                        event_attributes: event,
                    });
                }, event: order.event_attributes, activity: activity, errors: errors }),
            React.createElement(AdditionalInsureds, { orderId: order.id, errors: errors, defaultAdditionalInsured: defaultAdditionalInsured, additionalInsureds: order.organization_attributes.additional_insureds_attributes ||
                    [], states: states, onChange: (o) => {
                    onChange({
                        ...order,
                        organization_attributes: {
                            ...order.organization_attributes,
                            ...o,
                        },
                    });
                } })))));
};
